export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/live_action_explainers.c76f96d.svg";